import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { logisticApi } from 'redux/services/logistic'
import {
  ProcessedLogisticObject,
  RepeatLogisticParams,
} from 'redux/services/logistic/types'

import { AppButton } from 'components/AppButton'
import { AppModal } from 'components/AppModal'
import { TextField } from 'components/TextField'
import { TextFieldCalendar } from 'components/TextFieldCalendar'

import { LogisticStatus } from 'models/logistic'

import styles from './Repeat.module.scss'

interface Props {
  data: ProcessedLogisticObject
}
export function RepeatLogisticModal({ data }: Props) {
  const [open, setOpen] = useState(false)
  const {
    register,
    setValue,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<RepeatLogisticParams>({
    defaultValues: {
      address: data.address,
      status: LogisticStatus.repeat,
      start_delivery: data.start_delivery,
      end_delivery: data.end_delivery,
    },
  })
  const [submit, submitState] = logisticApi.useRepeatLogisticMutation()

  function onSubmit(values: RepeatLogisticParams) {
    submit({ id: data.id, body: values })
      .unwrap()
      .then(() => {
        closeModal()
      })
      .catch(err => {
        try {
          Object.entries(err.data.errors).forEach(([key, messages]) =>
            setError(key as keyof RepeatLogisticParams, {
              type: 'custom',
              message: Array.isArray(messages) ? messages[0] : messages,
            }),
          )
        } catch (error) {
          console.error(error)
        }
      })
  }

  const openModal = () => {
    setOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const closeModal = () => {
    setOpen(false)
    document.body.style.overflow = 'auto'
  }

  const startDate = new Date(data.start_delivery)

  return (
    <>
      <AppButton onClick={openModal} variant="siren_dashed_border">
        Повторная доставка
      </AppButton>
      {open && (
        <AppModal onClose={closeModal} title="Повторная доставка">
          <form onSubmit={handleSubmit(onSubmit)} className={styles.container}>
            <TextField
              {...register('address', {
                required: 'Обязательное поле',
              })}
              label="Адрес"
              withError
              error={errors.address}
            />

            <div
              style={{ display: 'flex', gap: '1rem', paddingBottom: '2rem' }}
            >
              <div style={{ flex: 1 }}>
                <TextFieldCalendar
                  required
                  onChangeDate={date => {
                    setValue(
                      'start_delivery',
                      `${date.date} ${date.hour}:${date.minute}`,
                    )
                  }}
                  label={`Время от`}
                  defaultValues={{
                    date: startDate,
                    hour: startDate.getHours(),
                    minute: startDate.getMinutes(),
                  }}
                  withError
                  error={errors.start_delivery}
                />
              </div>

              <div style={{ flex: 1 }}>
                <TextField
                  {...register('end_delivery')}
                  type="time"
                  required
                  label="до"
                  withError
                  error={errors.end_delivery}
                />
              </div>
            </div>

            <AppButton disabled={submitState.isLoading} type="submit">
              Отправить
            </AppButton>
          </form>
        </AppModal>
      )}
    </>
  )
}
